import React from "react";
import { FaCircle } from "react-icons/fa6";
import { LiaBuilding } from "react-icons/lia";
import { MdOutlineMonitor } from "react-icons/md";
import { useHistory } from "react-router-dom";

import type { Checkin } from "services/api/AppWeb_Checkin/listar_checkin";
import * as S from "./styles";

interface Props {
  data: Checkin;
  corretor: boolean;
}

const CheckinItem: React.FC<Props> = (props) => {
  const history = useHistory();

  const handleNavigate = (id: string) => {
    history.push(`/roleta-ao-vivo/${id}`);
  };

  return (
    <S.Container aoVivo={props?.data?.aoVivo && props?.corretor}>
      <S.RowSpace>
        <S.Row gap={32}>
          {!props?.corretor ? (
            <>
              <S.Row gap={8}>
                <S.Text style={{ fontWeight: "bold", minWidth: "30vw" }}>
                  Corretor: {props?.data?.nomeCorretor}
                </S.Text>
              </S.Row>
              <S.Row gap={8}>
                <LiaBuilding />
                <S.Text>{props?.data?.nomePlantaoVendas}</S.Text>
              </S.Row>
            </>
          ) : null}
          {props?.corretor ? (
            <>
              <S.Row gap={8}>
                <LiaBuilding />
                <S.Text style={{ minWidth: "30vw" }}>
                  {props?.data?.nomePlantaoVendas}
                </S.Text>
              </S.Row>
              <S.Text>Turno: {props?.data?.turno}</S.Text>
            </>
          ) : null}
        </S.Row>
        <S.Row gap={32}>
          {props?.data?.aoVivo && props?.corretor ? (
            <S.Button
              onClick={() => handleNavigate(props?.data?.idRoletaCheckin)}
            >
              <MdOutlineMonitor />
              Roleta ao vivo
            </S.Button>
          ) : null}
          <S.Text>
            {props?.data?.data} {props?.data?.hora}
          </S.Text>
          <FaCircle
            color={!props?.data?.posSorteio ? "#4CAF50" : "#F4A767"}
            size={16}
          />
        </S.Row>
      </S.RowSpace>
    </S.Container>
  );
};

export default CheckinItem;
